import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc/client";

export const useGetStudySetFolders = (id: string) => {
  const trpc = useTRPC();
  return useQuery(
    trpc.studysets.getFolders.queryOptions(
      { id },
      {
        staleTime: Number.POSITIVE_INFINITY,
        enabled: !!id,
      },
    ),
  );
};
